module.exports = __webpack_public_path__ + "static/media/montotox2.85f7179f.jpg";